import script from "./ActivityList.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityList.vue?vue&type=script&setup=true&lang=js"

import "./ActivityList.vue?vue&type=style&index=0&id=69582392&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69582392"]])

export default __exports__